import { IAddUpdatePrestacaoContasRequest } from "../../../../model/admin-portal/request/add-update-prestacao-contas-request";
import { IPrestacaoContasResponse } from "../../../../model/admin-portal/response/prestacao-contas-response";
import { ITipoDocumentoPrestacaoContasResponse } from "../../../../model/admin-portal/response/tipo-documento-prestacao-contas-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type PrestacaoContasState = {
    dataPaginatedListResponse: PaginationResponse<IPrestacaoContasResponse>;
    isLoadingData: boolean;
    dataResponse: IPrestacaoContasResponse | null;
    dataRequest: IAddUpdatePrestacaoContasRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    tiposList: ITipoDocumentoPrestacaoContasResponse[];
};

export const initialDataRequest: IAddUpdatePrestacaoContasRequest = {
    id: null,
    idTipoDocumentoPrestacaoContas: null,
    ano: null,
    anoFim: null,
    periodo: null,
    textoDescricao: '',
    indStatus: null,
    dtaPublicacao: '',
    documentos: []
};

export const initialState: PrestacaoContasState = {
    dataPaginatedListResponse: new PaginationResponse<IPrestacaoContasResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    tiposList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setTiposList = 'setTiposList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IPrestacaoContasResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IPrestacaoContasResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdatePrestacaoContasRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setTiposList; payload: ITipoDocumentoPrestacaoContasResponse[] };

export const prestacaoContasReducer = (state: PrestacaoContasState, action: Action): PrestacaoContasState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setTiposList:
            return { ...state, tiposList: action.payload };
        default:
            return state;
    }
};
